import {
  DefaultAnswerEnum,
  ReportQuestion,
  ResponseNumberSubTypeEnum,
  ResponseTypeEnum,
  RuleDefTypeEnum,
} from '@ulysses-inc/harami_api_client'

/**
 * 製品マスタの自動入力で値がない場合を判定する
 *
 * 以下のいずれかに該当する場合 true:
 * - defaultAnswer.type が ProductMaster かつ value が null/undefined
 * - ruleDefType が MASTER かつ製品マスタからのルールが存在しない
 *   （subType に応じて必要なフィールドが欠けている場合）
 */
export const hasNoProductMasterData = (
  question: ReportQuestion | undefined,
): boolean => {
  if (!question) return false

  switch (question.responseType) {
    case ResponseTypeEnum.NUMBER: {
      const responseNumber = (question.responseNumbers ?? [])[0]
      if (!responseNumber) return false

      const { defaultAnswer, ruleDefType } = responseNumber

      // defaultAnswer が ProductMaster で値がない
      if (
        defaultAnswer?.type === DefaultAnswerEnum.ProductMaster &&
        (defaultAnswer.value === null || defaultAnswer.value === undefined)
      ) {
        return true
      }

      // ruleDefType が MASTER で製品マスタからのルールが存在しない
      // subType に応じて必要なフィールドが異なる:
      //   BETWEEN: minimum と maximum の両方が必要
      //   GREATER_THAN: minimum が必要
      //   LESS_THAN: maximum が必要
      if (ruleDefType === RuleDefTypeEnum.Master) {
        const { subType } = responseNumber
        switch (subType) {
          case ResponseNumberSubTypeEnum.BETWEEN:
            if (
              responseNumber.minimum == null &&
              responseNumber.maximum == null
            ) {
              return true
            }
            break
          case ResponseNumberSubTypeEnum.GREATER_THAN:
            if (responseNumber.minimum == null) {
              return true
            }
            break
          case ResponseNumberSubTypeEnum.LESS_THAN:
            if (responseNumber.maximum == null) {
              return true
            }
            break
          default:
            // subType が未設定の場合はルールが存在しないとみなす
            if (
              responseNumber.minimum == null &&
              responseNumber.maximum == null
            ) {
              return true
            }
            break
        }
      }

      return false
    }
    case ResponseTypeEnum.TEXT: {
      const responseText = (question.responseTexts ?? [])[0]
      if (!responseText) return false

      const { defaultAnswer } = responseText

      if (
        defaultAnswer?.type === DefaultAnswerEnum.ProductMaster &&
        (defaultAnswer.value === null ||
          defaultAnswer.value === undefined ||
          defaultAnswer.value === '')
      ) {
        return true
      }

      return false
    }
    default:
      return false
  }
}
